'use client';

import type { useElevarEvents } from '.';
import type { CartFragment } from '../cart/cart-fragment';
import { serializeCartToElevarImpressions } from './elevar-helpers';

// Global state to prevent duplicate tracking across multiple hook instances
let isTrackingViewCart = false;
let lastTrackedCartId: string | null = null;
let lastTrackedCartTotalItems = 0;

export function trackViewCartGlobal({
  cartData,
  domain,
  trackViewCart,
}: {
  cartData: CartFragment;
  domain: string;
  trackViewCart: ReturnType<typeof useElevarEvents>['trackViewCart'];
}) {
  // Prevent duplicate tracking
  if (isTrackingViewCart) return false;

  // Check if cart is valid
  if (!cartData || cartData.cost.totalAmount.amount === '0.0') return false;

  // Check if we already tracked this exact cart state (ID + item count)
  const currentCartId = cartData?.id;
  const currentItemCount = cartData?.totalQuantity || 0;

  if (
    currentCartId &&
    currentCartId === lastTrackedCartId &&
    currentItemCount === lastTrackedCartTotalItems
  ) {
    return false;
  }

  // Set tracking flag
  isTrackingViewCart = true;

  try {
    trackViewCart({
      impressions: serializeCartToElevarImpressions({
        cart: cartData,
        domain,
      }),
    });

    lastTrackedCartId = currentCartId;
    lastTrackedCartTotalItems = currentItemCount;
    return true;
  } finally {
    // Reset flag after a short delay to allow for next opening
    setTimeout(() => {
      isTrackingViewCart = false;
    }, 100);
  }
}

export function resetCartViewTracking() {
  isTrackingViewCart = false;
  lastTrackedCartId = null;
  lastTrackedCartTotalItems = 0;
}
